import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PspBranchState } from '../reducers/base-psp-branch.reducer';

const getPspBranchState = createFeatureSelector<PspBranchState>('pspBranch');
export const getPspBranchListData = createSelector(getPspBranchState, (state) => state.pspBranch.data);
export const getPspBranchListStatus = createSelector(getPspBranchState, (state) => state.pspBranch.ok);
export const getPspBranchCrud = createSelector(getPspBranchState, (state) => state.pspBranch.crud);
export const getPspUserList = createSelector(getPspBranchState, (state) => state?.pspBranchUsers);
export const getCurrentBranch = createSelector(getPspBranchState, (state) => state.currentBranch);
export const getBranchInactiveFilter = createSelector(getPspBranchState, (state) => state.branchFilter.filterActive);
